/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthAccountRouteImport } from './routes/_auth/account'
import { Route as AuthBillingRouteImport } from './routes/_auth/billing'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicRegisterRouteImport } from './routes/_public/register'
import { Route as AuthAdminBillingRouteImport } from './routes/_auth/admin/billing'
import { Route as AuthAdminBroadcastsRouteImport } from './routes/_auth/admin/broadcasts'
import { Route as AuthAdminGlobalConfigRouteImport } from './routes/_auth/admin/global-config'
import { Route as AuthCampaignsCampaignIdRouteImport } from './routes/_auth/campaigns.$campaignId'
import { Route as AuthAdminUsersIndexRouteImport } from './routes/_auth/admin/users.index'
import { Route as AuthAdminUsersUserIdRouteImport } from './routes/_auth/admin/users.$userId'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingRoute = AuthBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicRegisterRoute = PublicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => PublicRoute,
} as any)
const AuthAdminBillingRoute = AuthAdminBillingRouteImport.update({
  id: '/admin/billing',
  path: '/admin/billing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminBroadcastsRoute = AuthAdminBroadcastsRouteImport.update({
  id: '/admin/broadcasts',
  path: '/admin/broadcasts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminGlobalConfigRoute = AuthAdminGlobalConfigRouteImport.update({
  id: '/admin/global-config',
  path: '/admin/global-config',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCampaignsCampaignIdRoute = AuthCampaignsCampaignIdRouteImport.update({
  id: '/campaigns/$campaignId',
  path: '/campaigns/$campaignId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminUsersIndexRoute = AuthAdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminUsersUserIdRoute = AuthAdminUsersUserIdRouteImport.update({
  id: '/admin/users/$userId',
  path: '/admin/users/$userId',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/account': typeof AuthAccountRoute
  '/billing': typeof AuthBillingRoute
  '/login': typeof PublicLoginRoute
  '/register': typeof PublicRegisterRoute
  '/admin/billing': typeof AuthAdminBillingRoute
  '/admin/broadcasts': typeof AuthAdminBroadcastsRoute
  '/admin/global-config': typeof AuthAdminGlobalConfigRoute
  '/campaigns/$campaignId': typeof AuthCampaignsCampaignIdRoute
  '/admin/users/$userId': typeof AuthAdminUsersUserIdRoute
  '/admin/users/': typeof AuthAdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthIndexRoute
  '/account': typeof AuthAccountRoute
  '/billing': typeof AuthBillingRoute
  '/login': typeof PublicLoginRoute
  '/register': typeof PublicRegisterRoute
  '/admin/billing': typeof AuthAdminBillingRoute
  '/admin/broadcasts': typeof AuthAdminBroadcastsRoute
  '/admin/global-config': typeof AuthAdminGlobalConfigRoute
  '/campaigns/$campaignId': typeof AuthCampaignsCampaignIdRoute
  '/admin/users/$userId': typeof AuthAdminUsersUserIdRoute
  '/admin/users': typeof AuthAdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_auth/account': typeof AuthAccountRoute
  '/_auth/billing': typeof AuthBillingRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/register': typeof PublicRegisterRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/admin/billing': typeof AuthAdminBillingRoute
  '/_auth/admin/broadcasts': typeof AuthAdminBroadcastsRoute
  '/_auth/admin/global-config': typeof AuthAdminGlobalConfigRoute
  '/_auth/campaigns/$campaignId': typeof AuthCampaignsCampaignIdRoute
  '/_auth/admin/users/$userId': typeof AuthAdminUsersUserIdRoute
  '/_auth/admin/users/': typeof AuthAdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/billing'
    | '/login'
    | '/register'
    | '/admin/billing'
    | '/admin/broadcasts'
    | '/admin/global-config'
    | '/campaigns/$campaignId'
    | '/admin/users/$userId'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/billing'
    | '/login'
    | '/register'
    | '/admin/billing'
    | '/admin/broadcasts'
    | '/admin/global-config'
    | '/campaigns/$campaignId'
    | '/admin/users/$userId'
    | '/admin/users'
  id:
    | '__root__'
    | '/_auth'
    | '/_public'
    | '/_auth/account'
    | '/_auth/billing'
    | '/_public/login'
    | '/_public/register'
    | '/_auth/'
    | '/_auth/admin/billing'
    | '/_auth/admin/broadcasts'
    | '/_auth/admin/global-config'
    | '/_auth/campaigns/$campaignId'
    | '/_auth/admin/users/$userId'
    | '/_auth/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/account': {
      id: '/_auth/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing': {
      id: '/_auth/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthBillingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/register': {
      id: '/_public/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof PublicRegisterRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/admin/billing': {
      id: '/_auth/admin/billing'
      path: '/admin/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AuthAdminBillingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/broadcasts': {
      id: '/_auth/admin/broadcasts'
      path: '/admin/broadcasts'
      fullPath: '/admin/broadcasts'
      preLoaderRoute: typeof AuthAdminBroadcastsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/global-config': {
      id: '/_auth/admin/global-config'
      path: '/admin/global-config'
      fullPath: '/admin/global-config'
      preLoaderRoute: typeof AuthAdminGlobalConfigRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/campaigns/$campaignId': {
      id: '/_auth/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof AuthCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/users/': {
      id: '/_auth/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AuthAdminUsersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/admin/users/$userId': {
      id: '/_auth/admin/users/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AuthAdminUsersUserIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAccountRoute: typeof AuthAccountRoute
  AuthBillingRoute: typeof AuthBillingRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAdminBillingRoute: typeof AuthAdminBillingRoute
  AuthAdminBroadcastsRoute: typeof AuthAdminBroadcastsRoute
  AuthAdminGlobalConfigRoute: typeof AuthAdminGlobalConfigRoute
  AuthCampaignsCampaignIdRoute: typeof AuthCampaignsCampaignIdRoute
  AuthAdminUsersUserIdRoute: typeof AuthAdminUsersUserIdRoute
  AuthAdminUsersIndexRoute: typeof AuthAdminUsersIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccountRoute: AuthAccountRoute,
  AuthBillingRoute: AuthBillingRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthAdminBillingRoute: AuthAdminBillingRoute,
  AuthAdminBroadcastsRoute: AuthAdminBroadcastsRoute,
  AuthAdminGlobalConfigRoute: AuthAdminGlobalConfigRoute,
  AuthCampaignsCampaignIdRoute: AuthCampaignsCampaignIdRoute,
  AuthAdminUsersUserIdRoute: AuthAdminUsersUserIdRoute,
  AuthAdminUsersIndexRoute: AuthAdminUsersIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicRegisterRoute: typeof PublicRegisterRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicRegisterRoute: PublicRegisterRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
